<div *ngIf="text" id="install-container--fluent" #installContainer>
    <ohp-dropdown-menu *ngIf="!isConsumer && !isMobile && showInstallButton" [menuModel]="menuModel" (toggleMenu)="onToggleMenu($event)" (selectItem)="onSelectItem($event)">
        <div ohpMenuLinkContent class="install-button-text--nooutline">
            <span class="generic-button__text">{{ installOfficeAppsButtonText }}</span>
            <ohp-icon-font iconFontName="ChevronDown"
                            [size]="10"
                            cssClass="install-button-icon--fluent">
            </ohp-icon-font>
        </div>
        <div *ohpDropdownMenuItemContent="let item = item; let index = index" class="install-link--fluent" [ngClass]="{ 'install-link-testhook': item.getId()!==additionalLinkId }">
            <ohp-icon-font [iconFontName]="item.iconName"
                           class="install-link__install-symbol--fluent ms-fcl-np"
                           *ngIf="showInstallSymbol">
            </ohp-icon-font>
            <!--TODO: Replace icon font with new document icon from sprite (item.icon)-->
            <div class="install-link__text-container--fluent">
            <div class="install-link__text-medium--fluent ms-fcl-np">{{ item.title }}</div>
                <div id="{{ item.ariaDescribedBy }}" class="install-link__text-small--fluent ms-fcl-np">{{ item.description }}</div>
            </div>
        </div>
    </ohp-dropdown-menu>
    <div *ngIf="!isConsumer && isMobile">
        <a id="{{ id }}"
           [ngClass]="{ 'no-install': !showInstallSymbol, 'generic-button--fluent--secondary ms-bgc-tp-h ms-bgc-tp-a ms-fcl-tp ms-fcl-w-h ms-fcl-w-a': !invertedThemeColors, 'generic-button--fluent--primary ms-bgc-tp ms-bgc-w-h ms-bgc-w-a ms-fcl-tp-h ms-fcl-tp-a': invertedThemeColors }"
           class="generic-button generic-button--fluent install-button--fluent"
           href="javascript:void(0)"
           [ohpInstrumentClick]="clickData"
           (click)="action()"
           [attr.aria-label]="ariaLabel">
            <ohp-icon-font iconFontName="Download"
                           class="install-link__install-symbol--fluent ms-fcl-np"
                           *ngIf="showInstallSymbol">
            </ohp-icon-font>
            <b>{{ installOfficeAppsButtonText }}</b>
        </a>
    </div>
    <div *ngIf="isConsumer && !temporaryHideInstall" >
        <div class="section__buttons-container install__buttons-container">
            <div *ngIf="showInstallButton" #consumerInstallContainer>
                <button id="{{ id }}"
                        class="install-button--fluent generic-button generic-button--fluent generic-button--fluent--secondary ms-fcl-tp ms-bgc-w ms-bgc-tp-h ms-bgc-tp-a ms-fcl-w-h ms-fcl-w-a"
                        [ngClass]="{ 'use-theme-color': showCommercialButton, 'use-primary-color': !showCommercialButton, 'no-install': !showInstallSymbol}"
                        (click)="onToggleConsumerDropdown()"
                        [attr.aria-label]="ariaLabel"
                        data-clicklog="custom">
                    <ohp-icon-font class="install-button__install-symbol-container--fluent ms-fcl-w-h"
                                   iconFontName="Download"
                                   cssClass="install-button__install-symbol--fluent"
                                   *ngIf="showInstallSymbol">
                    </ohp-icon-font>
                    <b>{{ text }}</b>
                </button>
                <div id="consumer-install-dropdown" *ngIf="expandConsumerInstallDropdown && showConsumerUpsell" class="consumer-install-dropdown">
                    <div class="go-premium-description" [innerHTML]="goPremiumDescription">
                    </div>
                    <div class="go-premium-link-container">
                        <a id="go-premium-link"
                           class="go-premium-link"
                           href="{{ goPremiumUrl }}"
                           ohpDefaultLinkTarget
                           (click)="launchDime($event, goPremiumDimeExperience, goPremiumUrl)"
                           [attr.data-area]="componentArea">
                            {{ goPremiumBtnText }}
                        </a>
                    </div>
                    <div class="have-product-key-link">
                        <a id="have-product-key-link"
                           href="{{ haveOfficeProductKeyUrl }}"
                           (click)="onToggleConsumerDropdown()"
                           [attr.data-area]="componentArea"
                           ohpDefaultLinkTarget>
                            {{ haveOfficeProductKeyLnkText }}
                        </a>
                    </div>
                    <div class="need-help-link">
                        <a id="need-help-link"
                           href="{{ needHelpInstallingOfficeUrl }}"
                           (click)="onToggleConsumerDropdown()"
                           [attr.data-area]="componentArea"
                           ohpDefaultLinkTarget>
                            {{ needHelpInstallingOfficeLnkText }}
                        </a>
                    </div>
                </div>
            </div>
            <div *ngIf="showConsumerUpsell">
                <a id="consumer-buy-button"
                   class="consumer-buy-office-link--fluent generic-button generic-button--fluent generic-button--fluent--primary ms-bgc-tp ms-fcl-w ms-bgc-w-h ms-bgc-w-a ms-fcl-tp-h ms-fcl-tp-a ms-fcl-w-f"
                   href="{{ buyOffice365Url }}"
                   (click)="launchDime($event, buyOffice365DimeExperience, buyOffice365Url)"
                   [attr.data-area]="componentArea"
                   ohpDefaultLinkTarget>
                    <b>{{ buyOffice365BtnText }}</b>
                </a>
            </div>
        </div>
    </div>
    <iframe #installerBinaryDownload style="display: none"></iframe>
</div>
